/**
 * api > 대시보드
 */

import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.Host}/${EndPoint.Statistics}`;

export async function getFields() {
  return await Client.get(`${endpoint}/getFields`, {}, true);
}

// 현장 상세
export async function getStatisticsField(id) {
  return await Client.get(`${endpoint}/field/${id}`, {}, true);
}
